var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultifatorial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 12.1875V10.3125H25.25V12.1875H14ZM14 15.9375V14.0625H25.25V15.9375H14ZM21.2794 19.6875H14V17.8125H21.2794V19.6875Z",
    fill: "#001574"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9039 43.8225H40.1378L44.3608 36.6797H19.1202L22.9039 43.8225Z",
    fill: "#007C6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8468 52.4807L23.3021 45.333L40.1836 45.3335L37.3424 52.4807H25.8468Z",
    fill: "#00D084"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8055 25.5762H47.6218C48.6807 25.5762 49.342 26.7871 48.8147 27.7531L44.5492 35.5538H18.8782L14.617 27.7531C14.0854 26.7871 14.7467 25.5762 15.8055 25.5762Z",
    fill: "#00D084"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultifatorial);
export default __webpack_public_path__ + "static/media/multifatorial.754daf2c86d0ff3c008a0e50e9f513bf.svg";
export { ForwardRef as ReactComponent };